import Skeleton from "react-loading-skeleton";
import clsx from "clsx";
import type { CSSProperties } from "react";

import classes from "./styles.module.scss";

export function GeneralSkeleton({ style }: { style?: CSSProperties }) {
  return (
    <div className={clsx(classes.container)}>
      <Skeleton width={"100%"} height={"100%"} style={style} />
    </div>
  );
}
